import React, { Component } from "react";
import styled from "styled-components";
import * as Widget from "./Widget2";

class StepItem extends Component {
  render() {
    let { data, number } = this.props;

    return (
      <Wrapper>
        <Widget.Col align="center">
          <IconImage
            src={`/images/pages/landing/icon-${data.img}.png`}
            css="margin-bottom: 5px;"
          />
          <Number css="margin-bottom: 10px;">{number + 1}.</Number>
          <Title css="margin-bottom: 8px;">{data.title}</Title>
          <Text>{data.description}</Text>
        </Widget.Col>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  margin: 30px;

  @media screen and (max-width: 1000px) {
    margin: 15px;
  }

  ${props => props.css || ""};
`;

const IconImage = styled.img`
  width: 150px;
  height: 150px;

  @media screen and (max-width: 768px) {
    width: 120px;
    height: 120px;
  }

  ${props => props.css || ""};
`;

const Number = styled.div`
  line-height: 30px;
  font-weight: 600;
  font-size: 32px;
  color: #bd9f84;

  ${props => props.css || ""};
`;

const Title = styled.div`
  letter-spacing: 1.57px;
  font-size: 22px;
  color: #4e4e4e;

  @media screen and (max-width: 768px) {
    font-size: 20px;
  }

  ${props => props.css || ""};
`;

const Text = styled.div`
  letter-spacing: 0.28px;
  font-size: 14px;

  @media screen and (max-width: 768px) {
    font-size: 12px;
  }
`;

export default StepItem;
